export const REACT_APP_GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

export const drawerWidth = '24rem';
export const headerHeight = '81px';
export const footerHeight = '90px';
